import * as PurchaseModes from "./purchaseModes";

export const analyticsResources = {
	ProductPage: "Página de Produto",
	Cart: "Carrinho",
	Insurances: "Modal Seguros",
	SelectInsurance: "Selecionar Seguro",
	AddToCart: "Adicionar ao carrinho",
	SelectColor: "Alterar cor",
	SelectPurchaseMode: "Alterar modo pagamento",
	SeeAllSpecs: "Ver todas as caracteristicas",
	NextImage: "Próxima imagem",
	PrevImage: "Imagem anterior",
	Gallery: "Galeria",
	GoBack: "Voltar",
	CrossSelling: "Cross-Selling",
	AddVoucher: "Adicionar voucher",
	FinishPurchase: "Finalizar encomenda",
	[PurchaseModes.PROMPT_PAYMENT]: "Pronto Pagamento",
	[PurchaseModes.FIDELIZATIONS]: "Fidelização",
	[PurchaseModes.POINTS]: "Pontos",
	[PurchaseModes.INSTALLMENTS]: "Prestações"
};

export class AnalyticsConstants {
	static get analytics() {
		return analyticsResources;
	}
}
